import { Heart } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

export default function SecurityPolicyPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="security-policy-page">
      {/* Header */}
      <header className="bg-white border-b border-border sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 text-primary">
              <Heart weight="fill" className="w-7 h-7" />
              <span className="text-xl font-bold font-[Manrope]">MEDICULDIGITAL</span>
            </Link>
            <Link 
              to="/register" 
              className="text-sm text-muted-foreground hover:text-primary transition-colors"
            >
              ← Înapoi la înregistrare
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <article className="prose prose-slate max-w-none">
          <h1 className="text-3xl font-bold font-[Manrope] text-foreground mb-8">
            Security Policy & TOMs
          </h1>
          
          <p className="text-muted-foreground mb-6">
            <strong>Last Updated:</strong> 25 iunie 2026
          </p>

          <p>
            NETWORK CONSULTANCY SERVICES LLC, NCS LLC, is a company registered in USA (business registration no. 5433202), with registered address: 16192 Coastal Highway, Lewes, Delaware 19958, USA. We prioritize the security of your data. This page outlines the Technical and Organizational Measures (TOMs) we implement to protect the confidentiality, integrity, and availability of our Service and our customers' data.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">1. Security Philosophy</h2>
          <p>
            We follow a "security by design" approach, integrating security best practices into our development lifecycle and infrastructure management. Our security program is designed to meet the requirements of the GDPR and other applicable data protection laws.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">2. Cloud Infrastructure and Hosting</h2>
          <h3 className="text-lg font-medium mt-4 mb-2">2.1. Cloud Providers</h3>
          <p>
            NCS LLC infrastructure is hosted primarily on the Google Cloud Platform (GCP), a premier tier-1 cloud provider with industry-leading security certifications (including ISO 27001, SOC 2 Type II, and GDPR compliance).
          </p>

          <h3 className="text-lg font-medium mt-4 mb-2">2.2. Physical Security</h3>
          <p>
            NCS LLC does not maintain physical servers. We rely on our cloud providers' physical security measures, which include 24/7 onsite security, biometric access controls, and video surveillance at their data centers.
          </p>

          <h3 className="text-lg font-medium mt-4 mb-2">2.3. Data Segregation</h3>
          <p>
            Our multi-tenant architecture is designed to logically segregate customer data using unique identifiers (such as Tenant IDs and User IDs).
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">3. Data Encryption</h2>
          <h3 className="text-lg font-medium mt-4 mb-2">3.1. Encryption in Transit</h3>
          <p>
            All data transmitted between your device and NCS LLC is encrypted using strong industry-standard protocols (TLS 1.2 or higher).
          </p>

          <h3 className="text-lg font-medium mt-4 mb-2">3.2. Encryption at Rest</h3>
          <p>
            Customer data stored in our databases, object storage, and backups is encrypted at rest using strong encryption standards (such as AES-256).
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">4. Access Control and Authentication</h2>
          <h3 className="text-lg font-medium mt-4 mb-2">4.1. User Authentication</h3>
          <p>
            We utilize robust authentication mechanisms to verify user identity. We do not store user passwords directly; instead, we rely on secure token-based authentication.
          </p>

          <h3 className="text-lg font-medium mt-4 mb-2">4.2. Internal Access (Least Privilege)</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Access is granted only to employees who require it for their role.</li>
            <li>Administrative access requires multi-factor authentication (MFA).</li>
            <li>Access rights are reviewed periodically.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">5. Network Security</h2>
          <p>
            Our infrastructure is protected by cloud-native firewalls and network security groups. We restrict network traffic to necessary protocols and ports, denying all other traffic by default.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">6. Application Security</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Code Reviews:</strong> All code changes undergo peer review before deployment.</li>
            <li><strong>Separation of Environments:</strong> We maintain separate environments for development, testing, and production.</li>
            <li><strong>Dependency Management:</strong> We regularly scan and update third-party libraries.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">7. Incident Response</h2>
          <h3 className="text-lg font-medium mt-4 mb-2">7.1. Incident Response Plan</h3>
          <p>We maintain an Incident Response Plan including procedures for detection, containment, eradication, and restoration.</p>

          <h3 className="text-lg font-medium mt-4 mb-2">7.2. Breach Notification</h3>
          <p>
            In the event of a confirmed Personal Data Breach, NCS LLC will notify affected customers without undue delay (typically within 72 hours).
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">8. Business Continuity</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Backups:</strong> Regular automated backups of critical data, encrypted and stored across multiple availability zones.</li>
            <li><strong>Resilience:</strong> Infrastructure designed for high availability with cloud scaling and redundancy.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">9. Responsible Disclosure</h2>
          <p>
            We welcome reports from security researchers regarding potential vulnerabilities.<br />
            <strong>Contact:</strong> security@wisanna.com
          </p>

          <hr className="my-8" />
          <p className="text-sm text-muted-foreground">© 2026 NCS LLC Legal. All rights reserved.</p>
        </article>
      </main>
    </div>
  );
}
